import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  ChartOptions,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler);

export interface SparklineChartProps {
  data: number[];
  color?: string;
  fillColor?: string;
  height?: number;
  showPoints?: boolean;
}

export default function SparklineChart({
  data,
  color = '#1976d2',
  fillColor,
  height = 60,
  showPoints = false,
}: SparklineChartProps) {
  const chartData = {
    labels: data.map((_, i) => i.toString()),
    datasets: [
      {
        data,
        borderColor: color,
        backgroundColor: fillColor || `${color}20`,
        borderWidth: 2,
        fill: !!fillColor,
        tension: 0.4,
        pointRadius: showPoints ? 2 : 0,
        pointHoverRadius: showPoints ? 4 : 0,
      },
    ],
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: showPoints,
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
      },
    },
    elements: {
      line: {
        borderWidth: 2,
      },
    },
  };

  return (
    <div style={{ height, width: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}
